import axios from '@/api'

export default {
  getSummary() {
    return axios.get('/Financial/daily-summary')
  }
}
